/* eslint-disable class-methods-use-this */
import { fetchDataToPrint } from '~/services/printer/dataToPrint';

export const PRINT_TYPES = {
  TABLE_SESSION: 'table_session',
  ORDER_BASKET: 'order_basket',
  INDIVIDUAL_BILL: 'individual_bill',
  CASHIER_OPENING_EVENT: 'cashier_opening_event',
  CASHIER_OPENING: 'cashier_opening',
  TERM_ACCOUNT: 'credit_register',
};

export const MOCK_NAMES = {
  MOCK_TABLE_SESSION_PRINTABLE_DATA: 'MOCK_TABLE_SESSION_PRINTABLE_DATA',
  MOCK_DELIVERY_IFOOD_PRINTABLE_DATA: 'MOCK_DELIVERY_IFOOD_PRINTABLE_DATA',
  MOCK_DELIVERY_NEEMO_PRINTABLE_DATA: 'MOCK_DELIVERY_NEEMO_PRINTABLE_DATA',
  MOCK_BALCONY_PRINTABLE_DATA: 'MOCK_BALCONY_PRINTABLE_DATA',
  MOCK_TOTEM_PRINTABLE_DATA: 'MOCK_TOTEM_PRINTABLE_DATA',
  MOCK_DELIVERY_99FOOD_PRINTABLE_DATA: 'MOCK_DELIVERY_99FOOD_PRINTABLE_DATA',
  MOCK_DELIVERY_REGULAR_PRINTABLE_DATA: 'MOCK_DELIVERY_REGULAR_PRINTABLE_DATA',
  MOCK_TABLE_DISCOUNTS_PRINTABLE_DATA: 'MOCK_TABLE_DISCOUNTS_PRINTABLE_DATA',
  MOCK_CASHIER_ENTRADA_PRINTABLE_DATA: 'MOCK_CASHIER_ENTRADA_PRINTABLE_DATA',
  MOCK_CASHIER_SANGRIA_BANK_PRINTABLE_DATA:
    'MOCK_CASHIER_SANGRIA_BANK_PRINTABLE_DATA',
  MOCK_CASHIER_SANGRIA_EXPENSE_PRINTABLE_DATA:
    'MOCK_CASHIER_SANGRIA_EXPENSE_PRINTABLE_DATA',
  MOCK_CASHIER_OPENING_PRINTABLE_DATA: 'MOCK_CASHIER_OPENING_PRINTABLE_DATA',
};

export class HtmlToPrintService {
  async fetchPrintableHtml(payload) {
    try {
      const formattedPayload = this._formatPayload(payload);
      const htmlContent = await fetchDataToPrint(formattedPayload);
      return htmlContent;
    } catch (error) {
      let errorMessage = 'Failed to fetch printable HTML';
      if (error.response?.data?.message) {
        errorMessage = error.response.data.message;
      } else if (error.message) {
        errorMessage = error.message;
      }
      throw new Error(errorMessage);
    }
  }

  _formatPayload({ print_type, id, mock_name }) {
    if (mock_name) {
      return { mock_name };
    }
    const basePayload = { print_type };
    switch (print_type) {
      case PRINT_TYPES.TABLE_SESSION:
        return {
          ...basePayload,
          table_session_id: id,
        };
      case PRINT_TYPES.ORDER_BASKET:
        return {
          ...basePayload,
          order_basket_id: id,
        };
      case PRINT_TYPES.INDIVIDUAL_BILL:
        return {
          ...basePayload,
          individual_bill_id: id,
        };
      case PRINT_TYPES.CASHIER_OPENING_EVENT:
        return {
          ...basePayload,
          cashier_opening_event_id: id,
        };
      case PRINT_TYPES.CASHIER_OPENING:
        return {
          ...basePayload,
          cashier_opening_id: id,
        };
      case PRINT_TYPES.TERM_ACCOUNT:
        return {
          ...basePayload,
          credit_register_id: id,
        };
      default:
        throw new Error(`Unsupported print type: ${print_type}`);
    }
  }

  validatePrintRequest({ print_type, id, mock_name }) {
    if (mock_name) {
      if (!Object.values(MOCK_NAMES).includes(mock_name)) {
        throw new Error(`Invalid mock name: ${mock_name}`);
      }
      return true;
    }
    if (!print_type) {
      throw new Error('Print type is required');
    }
    if (!Object.values(PRINT_TYPES).includes(print_type)) {
      throw new Error(`Invalid print type: ${print_type}`);
    }
    if (!id || (typeof id !== 'string' && typeof id !== 'number')) {
      throw new Error('Valid ID is required');
    }
    return true;
  }

  getPrintTypeLabel(print_type) {
    const labels = {
      [PRINT_TYPES.TABLE_SESSION]: 'Comanda',
      [PRINT_TYPES.ORDER_BASKET]: 'Pedido',
      [PRINT_TYPES.INDIVIDUAL_BILL]: 'Conta Individual',
      [PRINT_TYPES.CASHIER_OPENING_EVENT]: 'Evento de Caixa',
      [PRINT_TYPES.CASHIER_OPENING]: 'Abertura de Caixa',
      [PRINT_TYPES.TERM_ACCOUNT]: 'Conta a prazo',
    };
    return labels[print_type] || print_type;
  }

  getPrintTypeOptions() {
    return Object.values(PRINT_TYPES).map((type) => ({
      value: type,
      label: this.getPrintTypeLabel(type),
    }));
  }

  getMockNameLabel(mock_name) {
    return mock_name
      .split('_')
      .map((word) => word.charAt(0) + word.slice(1).toLowerCase())
      .join(' ');
  }

  getMockNameOptions() {
    return Object.values(MOCK_NAMES).map((mock) => ({
      value: mock,
      label: this.getMockNameLabel(mock),
    }));
  }
}

export default new HtmlToPrintService();
